import { ChangeDetectionStrategy, Component, Renderer2, effect, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ThemeLayoutService } from '@services/theme-layout.service';

@Component({
  selector: 'app-configuration',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
    NgScrollbarModule
  ],
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurationComponent {
  private readonly renderer = inject(Renderer2);
  readonly themeService = inject(ThemeLayoutService);
  readonly styleSelectorToggle = signal(false);

  constructor() {
    effect((onCleanup) => {
      const currentTheme = this.themeService.theme();
      this.renderer.addClass(document.body, currentTheme);
      onCleanup(() => {
        this.renderer.removeClass(document.body, currentTheme);
      });
    });

    effect((onCleanup) => {
      const currentBodyColor = this.themeService.bodyColor();
      this.renderer.addClass(document.body, currentBodyColor);

      onCleanup(() => {
        this.renderer.removeClass(document.body, currentBodyColor);
      });
    });
  }

  onSetLayouts(mode: 'light' | 'dark' | 'auto'): void {
    this.themeService.setLayoutType(mode);
  }

  onResetLayout(): void {
    this.themeService.resetConfig();
    this.styleSelectorToggle.set(false);
  }
}
